import map from 'lodash-es/map'
import type { ChangeEvent } from 'react'
import React from 'react'

import { RadioButton, withFormikSupport } from '@fourthwall/components'

import { Label } from '../../components/Label/Label'
import * as S from './Radio.styled'
import type { Props } from './types'

const RadioComponent = ({ data, value, onChange, onSettingUpdate }: Props) => {
  const { id, label, options, info } = data

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e)
    }

    onSettingUpdate(id, e.target.value)
  }

  const renderOptions = () => {
    return map(options, (option) => (
      <S.RadioContainer>
        <RadioButton
          checkedValue={option.value}
          label={option.label}
          value={value}
          onChange={handleChange}
        />
      </S.RadioContainer>
    ))
  }

  return (
    <>
      <Label info={info}>{label}</Label>
      {renderOptions()}
    </>
  )
}

export const Radio = withFormikSupport(RadioComponent)
